import { render, staticRenderFns } from "./MembersCard.vue?vue&type=template&id=6ec59e96&scoped=true"
import script from "./MembersCard.vue?vue&type=script&lang=js"
export * from "./MembersCard.vue?vue&type=script&lang=js"
import style0 from "./MembersCard.vue?vue&type=style&index=0&id=6ec59e96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec59e96",
  null
  
)

export default component.exports